export enum FiltersMapItemBlock {
  Root = 'FiltersMapItem',
}

export enum FiltersMapItemElement {
  Title = 'title',
}
